import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col } from "react-bootstrap";
import { FaFileContract, FaMoneyBillWave, FaPlaneSlash, FaPassport, FaGavel, FaExclamationTriangle } from "react-icons/fa";

import Navr from "../Navbar/Navr";
import Footer from "./Footer";
// import "./Terms.css"; // Custom CSS

export default function Terms() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <Navr />

      {/* --- Header Section --- */}
      <div className="terms-header text-center py-5">
        <Container>
          <div data-aos="fade-down">
             <FaFileContract className="text-danger display-3 mb-3" />
             <h1 className="fw-bold text-dark">Terms & Conditions</h1>
             <p className="text-muted">Please read these terms carefully before booking.</p>
             <div className="separator mx-auto"></div>
          </div>
        </Container>
      </div>

      {/* --- Content Section --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="terms-content">
                
                <p className="lead text-dark mb-5 text-center" data-aos="fade-up">
                  Welcome to <strong>Jawali Holidays</strong>. By booking a trip with us, you agree to the following terms and conditions. 
                  These terms ensure a clear understanding between the company and the traveler.
                </p>

                {/* Term 1: Booking & Payment */}
                <div className="term-card mb-4" data-aos="fade-up">
                  <div className="term-icon">
                    <FaMoneyBillWave />
                  </div>
                  <div className="term-text">
                    <h4 className="fw-bold text-dark">1. Booking & Payments</h4>
                    <ul>
                      <li>To confirm a booking, an advance payment of <strong>50%</strong> of the total tour cost is required.</li>
                      <li>The remaining <strong>50%</strong> must be paid 15 days prior to the departure date.</li>
                      <li>For bookings made within 10 days of travel, 100% payment is required upfront.</li>
                      <li>Payments can be made via Bank Transfer, UPI, Credit Card, or Cash at our office.</li>
                    </ul>
                  </div>
                </div>

                {/* Term 2: Cancellation Policy */}
                <div className="term-card mb-4" data-aos="fade-up">
                  <div className="term-icon">
                    <FaPlaneSlash />
                  </div>
                  <div className="term-text">
                    <h4 className="fw-bold text-dark">2. Cancellation & Refund Policy</h4>
                    <p className="text-muted mb-2">If you wish to cancel your trip, the following charges will apply:</p>
                    <ul>
                      <li><strong>30 Days before travel:</strong> 10% of total tour cost charged as processing fee.</li>
                      <li><strong>15-29 Days before travel:</strong> 50% cancellation charge.</li>
                      <li><strong>0-14 Days before travel:</strong> 100% cancellation charge (No Refund).</li>
                      <li>Refunds (if applicable) will be processed within 7-10 working days.</li>
                    </ul>
                  </div>
                </div>

                {/* Term 3: Travel Documents */}
                <div className="term-card mb-4" data-aos="fade-up">
                  <div className="term-icon">
                    <FaPassport />
                  </div>
                  <div className="term-text">
                    <h4 className="fw-bold text-dark">3. Travel Documents</h4>
                    <ul>
                      <li>It is the traveler's responsibility to carry valid IDs (Aadhar Card, Voter ID, Passport).</li>
                      <li>For international trips, passport must be valid for at least 6 months from travel date.</li>
                      <li>Jawali Holidays is not responsible for visa rejections by the embassy.</li>
                    </ul>
                  </div>
                </div>

                {/* Term 4: Liabilities */}
                <div className="term-card mb-4" data-aos="fade-up">
                  <div className="term-icon">
                    <FaExclamationTriangle />
                  </div>
                  <div className="term-text">
                    <h4 className="fw-bold text-dark">4. Liabilities & Responsibilities</h4>
                    <ul>
                      <li>We are not responsible for delays or cancellations due to "Force Majeure" (Natural disasters, strikes, flight cancellations, weather conditions).</li>
                      <li>Any extra cost incurred due to such unforeseen circumstances must be borne by the traveler.</li>
                      <li>Take care of your luggage and valuables; the company is not liable for theft or loss.</li>
                    </ul>
                  </div>
                </div>

                {/* Term 5: Jurisdiction */}
                <div className="term-card mb-4" data-aos="fade-up">
                  <div className="term-icon">
                    <FaGavel />
                  </div>
                  <div className="term-text">
                    <h4 className="fw-bold text-dark">5. Jurisdiction</h4>
                    <p className="text-muted">
                      Any legal disputes arising out of the agreement will be subject to the exclusive jurisdiction of the courts in <strong>Jodhpur, Rajasthan</strong>.
                    </p>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Footer Note --- */}
      <section className="py-4 bg-light text-center border-top">
         <Container>
           <p className="text-muted small mb-0">
             *Jawali Holidays reserves the right to change these terms without prior notice.
           </p>
         </Container>
      </section>

      <Footer />
    </div>
  );
}